import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import DOMPurify from 'dompurify';

function TermsAndConditions() {
    const [termsAndConditionsRef, isTermsAndConditionsVisible] = useScrollAnimation({ threshold: 0.15 });
    const [termsContent, setTermsContent] = useState('');
    
    useEffect(() => {
        fetch('/terms-and-conditions.html')
            .then(response => response.text())
            .then(html => {
                const sanitizedHtml = DOMPurify.sanitize(`<div>${html}</div>`);
                setTermsContent(sanitizedHtml);
            })
            .catch((error) => {
                console.error('Error fetching terms', error);
            });
    }, []);

    return (
        <div className="bg-[#f3f3f3] pb-4 pt-20 font-nunito min-h-screen">
            <div
                ref={termsAndConditionsRef}
                className={`max-w-7xl mx-auto px-5 py-10 bg-white rounded-[20px] p-12 m-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform ${isTermsAndConditionsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
            >
                <div>
                    <div className="bg-white rounded-lg max-h-screen overflow-y-auto shadow-2xl w-full flex flex-col">
                        <div className="flex-1 overflow-y-auto p-6">
                            <div
                                dangerouslySetInnerHTML={{ __html: termsContent }}
                                className="prose prose-sm max-w-none font-nunito"
                            />
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    );
}

export default TermsAndConditions;